import { Download } from "lucide-react";
import { Button } from "../ui/button";
import { openAttachment } from "../../lib/files";
import { fmtDate } from "../../lib/labels";
import { INVOICE_STATUS, Pill, money } from "../../lib/billingLabels";

export default function InvoiceList({ items, pdfBase, actions, testId = "invoice-list", showCompany = false }) {
  if (!items.length) return <p className="p-4 text-sm text-slate-500" data-testid={`${testId}-empty`}>Aucune facture.</p>;
  return (
    <div className="overflow-x-auto" data-testid={testId}>
      <table className="w-full min-w-[820px] text-sm">
        <thead className="border-b bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
          <tr><th className="px-4 py-3">N°</th>{showCompany && <th className="px-4 py-3">Entreprise</th>}<th className="px-4 py-3">Période</th><th className="px-4 py-3">Total</th><th className="px-4 py-3">Payé</th><th className="px-4 py-3">Solde</th><th className="px-4 py-3">Échéance</th><th className="px-4 py-3">Statut</th><th className="px-4 py-3 text-right">Actions</th></tr>
        </thead>
        <tbody className="divide-y">{items.map((i) => (
          <tr key={i.id} data-testid={`invoice-row-${i.number}`}>
            <td className="px-4 py-3 font-mono text-xs">{i.number}</td>
            {showCompany && <td className="px-4 py-3">{i.company_name}</td>}
            <td className="px-4 py-3 text-xs text-slate-500">{fmtDate(i.period_start, false)} – {fmtDate(i.period_end, false)}</td>
            <td className="px-4 py-3">{money(i.total, i.currency)}</td>
            <td className="px-4 py-3">{money(i.amount_paid, i.currency)}</td>
            <td className="px-4 py-3 font-medium">{money(i.balance, i.currency)}</td>
            <td className="px-4 py-3 text-xs">{fmtDate(i.due_at, false)}</td>
            <td className="px-4 py-3"><Pill map={INVOICE_STATUS} value={i.status} testId={`invoice-status-${i.number}`} /></td>
            <td className="space-x-1 whitespace-nowrap px-4 py-3 text-right">
              <Button size="sm" variant="ghost" onClick={() => openAttachment(`${pdfBase}/${i.id}/pdf`)} data-testid={`invoice-pdf-${i.number}`}><Download className="mr-1 h-3.5 w-3.5" />PDF</Button>
              {actions && actions(i)}
            </td>
          </tr>))}</tbody>
      </table>
    </div>
  );
}
